import { maskCEP } from "../../../utils/validacaoDadosPaciente";

export default function Insert(dadosIniciais, setDadadosIniciais) {
  setDadadosIniciais(prevState => ({
    ...prevState,
    nome: dadosIniciais.nome ?? "",
    nomeSocial: dadosIniciais.nomeSocial,
    nomeDaMae: dadosIniciais.nomeMae,
    email: dadosIniciais.email,
    dataNascimento: dadosIniciais.dataNascimento,
    estadoNascimento: dadosIniciais.estadoNascimento.id.toString(),
    municipioNascimento: dadosIniciais.municipioNascimento.id,
    sexo: dadosIniciais.sexo.id,
    raca: dadosIniciais.raca.id,
    identidadeDeGenero: dadosIniciais.identidadeDeGenero.id,
    estadoCivil: dadosIniciais.estadoCivil.id,
    religiao: dadosIniciais.religiao.id,
    naturalidade: dadosIniciais.naturalidade.id,
    lateralidade: dadosIniciais.lateralidade.id,
    escolaridade: dadosIniciais.escolaridade.id,
    profissao: parseInt(dadosIniciais.profissao.id),
    tipoDeTrabalho: dadosIniciais.tipoDeTrabalho.id,
    condicaoAtual: dadosIniciais.condicaoAtual.id,
    quantoTempo: dadosIniciais.tempoDedicacao,
    ultimasAtividades: dadosIniciais.atividadesProfissionais,
    enderecoCep: maskCEP(dadosIniciais.endereco.cep),
    enderecoUf: dadosIniciais.endereco.estado.descricao,
    enderecoCodigoUf: dadosIniciais.endereco.estado.id,
    enderecoMunicipio: dadosIniciais.endereco.municipio.descricao,
    enderecoIBGE: parseInt(dadosIniciais.endereco.municipio.id),
    enderecoLogradouro: dadosIniciais.endereco.logradouro,
    enderecoBairro: dadosIniciais.endereco.bairro,
    enderecoNumero: dadosIniciais.endereco.numero,
    enderecoComplemento: dadosIniciais.endereco.complemento,
    dadosDeContato: [
      {
        telefone: dadosIniciais.contato.telefone,
        nome: dadosIniciais.contato.responsavel,
      },
    ],
  }));
}
